import { z } from "zod";
import { visitSchema } from "./visits";

// A visit as the logistics host sends it, with the patient still an id. See
// activities.unenriched.ts for why the two are joined in the client.
export const unenrichedVisitSchema = visitSchema
  .omit({ patient: true })
  .extend({ patientId: z.uuid() });
export type IUnenrichedVisit = z.infer<typeof unenrichedVisitSchema>;
